import { connect } from 'react-redux'
import App from './app.js'
import {
    actionAutoLaunchOnStartup,
    actionUpdateAutoLaunchOnStartup,
    actionAppSetAutoLaunchEnabledState,
} from '../actions'
import { selectors as backendSelectors } from '../features/Backend'
import { selectors as profileSelectors } from '../features/ProfileSelector'
import { launcherJavaScriptReady } from '../launcherBackend'

function mapStateToProps(state) {
    const { app } = state
    const locale = backendSelectors.getLocale(state)
    const serverId = backendSelectors.getActiveServerId(state)
    return {
        isBackendReady: backendSelectors.isBackendReady(state),
        showRatings: locale !== 'zh',
        showProfileSelector: profileSelectors.isOpen(state),
        showSettings: app.showSettings,
        // Note that this is incorrectly named as an action!
        isAutoLaunchEnabled: actionAutoLaunchOnStartup,
        setAutoLaunchUrlParameter: actionUpdateAutoLaunchOnStartup,
        javaScriptReady: () => {
            launcherJavaScriptReady(serverId)
        },
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setAutoLaunchEnabledState: (enabled) => {
            dispatch(actionAppSetAutoLaunchEnabledState(enabled))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/App/app-container.js